import { ref, uploadBytes, getDownloadURL, deleteObject } from "firebase/storage";
import { storage } from "./api_firebase";

export const subirArchivoFirebase = async (ruta, archivo) => {
  const archivoRef = ref(storage, ruta);
  await uploadBytes(archivoRef, archivo);
  return await getDownloadURL(archivoRef);
};

export const borrarArchivoFirebaseUrl = async (url) => {
  if (!url) return;
  try {
    await deleteObject(ref(storage, url));
  } catch (e) {
    console.warn("No se pudo borrar el archivo en Storage:", e);
  }
};
